import { render, staticRenderFns } from "./otpForm.vue?vue&type=template&id=273688c3&scoped=true&"
import script from "./otpForm.vue?vue&type=script&lang=js&"
export * from "./otpForm.vue?vue&type=script&lang=js&"
import style0 from "./otpForm.vue?vue&type=style&index=0&id=273688c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273688c3",
  null
  
)

export default component.exports